import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { InterestTagConfig } from '@kawai/shared';
import { fetchInterestTagConfig } from '../repositories/interestTagConfigs.js';

/**
 * M-62 (promo): 自テナントの興味タグ設定を取得する React Query hook。
 *
 * cache key: `['promo', 'interestTagConfig', tenantId]`
 * - tenantId が null/undefined の間は disabled
 * - 未作成テナントは null（呼出側は既定マッピングにフォールバック）
 * - 保存後は `queryClient.invalidateQueries({ queryKey: ['promo', 'interestTagConfig'] })`
 *   + 興味タグが変わるため users 系（`['promo','users']`）も invalidate する
 */
export function useInterestTagConfig(
  tenantId: string | null | undefined,
): UseQueryResult<InterestTagConfig | null, Error> {
  return useQuery({
    queryKey: ['promo', 'interestTagConfig', tenantId],
    queryFn: () => fetchInterestTagConfig(tenantId as string),
    enabled: !!tenantId,
    staleTime: 60 * 1000,
  });
}
